// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import SelectList from "metabase/common/components/SelectList";

export const OptionsList = styled(SelectList)`
  padding: 0.5rem;
  min-width: 300px;
`;
